import script from "./ChartScoreSalud.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartScoreSalud.vue?vue&type=script&setup=true&lang=js"

import "./ChartScoreSalud.vue?vue&type=style&index=0&id=1aff2173&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aff2173"]])

export default __exports__